import React, { Component } from 'react';
import Card from './DroppableCard';
import { DropTarget } from 'react-dnd';
import update from 'immutability-helper';
import * as MySettings from '../store/Settings';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class Container extends Component {

	constructor(props) {
		super(props);


		this.state = {
			cards: props.list,
			name: props.name
		};

		this.props.settingsDispatch.set( props.name, props.list );
	}

	shouldComponentUpdate() {
		if ( this.props.refresh ) {
			this.setState({ cards: this.props.list });
		}
		return true;
	}

	pushCard(card) {
		this.setState(update(this.state, {
			cards: {
				$push: [ card ]
			}
		}));
		this.props.settingsDispatch.set(this.state.name, this.state.cards);
	}

	removeCard(index) {
		this.setState(update(this.state, {
			cards: {
				$splice: [
					[index, 1]
				]
			}
		}));
		this.props.settingsDispatch.set(this.state.name, this.state.cards);
	}

	moveCard(dragIndex, hoverIndex) {
		const { cards } = this.state;
		const dragCard = cards[dragIndex];

		this.setState(update(this.state, {
			cards: {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, dragCard]
				]
			}
		}));
		this.props.settingsDispatch.set(this.state.name, this.state.cards);
	}

	render() {
		const { cards } = this.state;
		const { canDrop, isOver, connectDropTarget } = this.props;
		const isActive = canDrop && isOver;

		const backgroundColor = isActive ? 'lightyellow' : '#FFF';

		return connectDropTarget(
			<div className="droppableColumns" style={{backgroundColor: backgroundColor}}>
				{cards && cards.map((card, i) => {
					return (
						<Card
							key={card.sortOrder}
							index={i}
							listId={this.props.id}
							card={card}
							removeCard={this.removeCard.bind(this)}
							moveCard={this.moveCard.bind(this)} />
					);
				})}
			</div>
		);
  }
}

const cardTarget = {
	drop(props, monitor, component ) {
		const { id } = props;
		const sourceObj = monitor.getItem();
		if ( id !== sourceObj.listId ) component.pushCard(sourceObj.card);
		return {
			listId: id
		};
	}
}

var dropService = DropTarget("CARD", cardTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))(Container);

export default connect(
    state => ({
        settingsState: state.settings
    }),
    dispatch => ({
        settingsDispatch: bindActionCreators(MySettings.actionCreators, dispatch)
    })
)(dropService);




// WEBPACK FOOTER //
// ./src/components/DroppableContainer.js